import { createDealerAxios } from 'src/factories/axios-factory';
import type { AddressLookupResult, AddressLookupResultItem } from 'src/types/address';

const dealerBackend = createDealerAxios(process.env.DealersApiUrl!);

const addressService = {
  addressLookup(key: string) {
    return new Promise<AddressLookupResultItem[]>((resolve, reject) => {
      dealerBackend.get(
        `/address/search?key=${key}`
      ).then(res => {
        const r = res.data as AddressLookupResult;
        if (r.Result === "1") {
          resolve(r.Item);
        }
        reject(false)
      }).catch(error => {
          reject(error);
      })
    })
  },
  addressByKey(key: string) {
    return new Promise<any>((resolve, reject) => {
      dealerBackend.get(
        `/address/key?key=${key}`
      ).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error);
      })
    })
  },
};

export default addressService;
